import React from 'react';
import { Music, Target, BookOpen, DollarSign, Briefcase, Brain } from 'lucide-react';
export function BonosSection() {
  const bonuses = [{
    number: 1,
    title: 'Playlist de frecuencias binaurales para deep focus',
    description: 'Curaduría de frecuencias binaurales y lo-fi diseñada científicamente para inducir estados de flujo profundo.',
    icon: Music,
    value: '$12.99'
  }, {
    number: 2,
    title: 'IKIGAI: Revela tu propósito',
    description: 'Plantilla guiada para descubrir tu propósito de vida usando el método japonés IKIGAI. Encuentra la intersección entre lo que amas, lo que el mundo necesita, en lo que eres bueno y por lo que te pueden pagar.',
    icon: Target,
    value: '$9.99'
  }, {
    number: 3,
    title: 'GPT experto en hábitos y gestión emocional',
    description: 'Acceso a un GPT personalizado entrenado específicamente en formación de hábitos, gestión emocional y productividad. Tu coach personal disponible 24/7.',
    icon: Brain,
    value: '$14.99'
  }, {
    number: 4,
    title: 'Diario de gratitud',
    description: 'Plantilla de diario de gratitud para cultivar una mentalidad positiva y reducir el estrés. Incluye prompts diarios y reflexiones semanales.',
    icon: BookOpen,
    value: '$7.99'
  }, {
    number: 5,
    title: 'Tracker de finanzas personales',
    description: 'Sistema completo para rastrear ingresos, gastos y ahorros. Visualiza tu salud financiera y toma control de tu dinero con claridad.',
    icon: DollarSign,
    value: '$8.99'
  }, {
    number: 6,
    title: 'Banco de recursos para emprendedores',
    description: 'Colección curada de herramientas, plantillas y recursos esenciales para emprendedores. Desde validación de ideas hasta estrategias de crecimiento.',
    icon: Briefcase,
    value: '$12.99'
  }];
  const totalValue = bonuses.reduce((sum, bonus) => {
    return sum + parseFloat(bonus.value.replace('$', ''));
  }, 0);
  return <section id="bonos" className="py-24 bg-[#0A0A0A]" data-id="element-23">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-24">
        <div className="text-center mb-16" data-id="element-25">
          <h2 className="text-2xl md:text-3xl font-bold text-white uppercase tracking-tight mb-2" data-id="element-26">
            Incluido <span className="text-[#FF6B35]" data-id="element-27">Gratis</span> con tu orden
          </h2>
          <p className="text-gray-500 mb-4" data-id="element-28">
            Herramientas adicionales para potenciar tu enfoque
          </p>
          <div className="inline-flex items-center gap-2 bg-[#FF6B35]/10 border border-[#FF6B35]/30 rounded-full px-4 py-2" data-id="element-29">
            <span className="text-gray-400 text-sm" data-id="element-30">Valor total de bonos:</span>
            <span className="text-[#FF6B35] font-bold text-lg" data-id="element-31">
              ${totalValue.toFixed(2)}
            </span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-32">
          {bonuses.map(bonus => {
          const Icon = bonus.icon;
          return <div key={bonus.number} className="bg-[#121212] border border-white/5 p-6 md:p-8 rounded-2xl" data-id="element-33">
                <div className="flex items-start gap-4 md:gap-6" data-id="element-34">
                  <div className="bg-gray-900 p-3 md:p-4 rounded-xl text-[#FF6B35] flex-shrink-0" data-id="element-35">
                    <Icon size={28} className="md:w-8 md:h-8" data-id="element-36" />
                  </div>
                  <div className="flex-1" data-id="element-37">
                    <div className="flex items-center justify-between mb-2" data-id="element-38">
                      <div className="text-[#FF6B35] text-xs font-bold uppercase" data-id="element-39">
                        Bono #{bonus.number}
                      </div>
                      <div className="text-gray-500 text-sm line-through" data-id="element-40">
                        {bonus.value}
                      </div>
                    </div>
                    <h3 className="text-lg md:text-xl font-bold text-white mb-2" data-id="element-41">
                      {bonus.title}
                    </h3>
                    <p className="text-gray-400 text-sm leading-relaxed" data-id="element-42">
                      {bonus.description}
                    </p>
                  </div>
                </div>
              </div>;
        })}
        </div>

        {/* Value Stack Summary */}
        <div className="mt-12 text-center" data-id="element-43">
          <div className="inline-block bg-[#121212] border border-[#FF6B35]/30 rounded-2xl p-6 md:p-8" data-id="element-44">
            <p className="text-gray-400 text-sm mb-2" data-id="element-45">
              Valor total del paquete completo:
            </p>
            <div className="flex items-center justify-center gap-4" data-id="element-46">
              <span className="text-3xl md:text-4xl font-bold text-gray-500 line-through" data-id="element-47">
                ${(totalValue + 17.99).toFixed(2)}
              </span>
              <span className="text-4xl md:text-5xl font-black text-[#FF6B35]" data-id="element-48">
                $17.99
              </span>
            </div>
            <p className="text-gray-500 text-xs mt-2" data-id="element-49">
              Ahorrás ${totalValue.toFixed(2)} en bonos • Oferta por tiempo
              limitado
            </p>
          </div>
        </div>
      </div>
    </section>;
}